/**
 * FIXME: This currently just displays the images at the right size but does not
 * resize them to the necessary size. This means that for some images we load
 * a lot of data for nothing. This was done like this in Rails:
 *
 * <%= image_fu(url, '310x196#') %>
 */
export function CoverImage({ url }: { url: string }) {
  return (
    <div
      className="portrait__photo"
      style={{
        width: "100%",
        paddingBottom: "63.23%",
        marginBottom: 10,
        backgroundImage: `url(${url})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top right",
      }}
    />
  );
}
